import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core';
import { assetsReportingDashboardUrl } from '../../Constants/Api';
import PieChartIcon from '@material-ui/icons/PieChart';

const useStyles = makeStyles((theme) => ({
	icon: { color: 'white' },
}));

function AssetReportingBtn() {
	const classes = useStyles();
	return (
		<Tooltip title="Asset Reporting Dashboard" aria-label="asset-reporting" placement="bottom">
			<IconButton
				className={classes.icon}
				key="asset-reporting-dashboard"
				onClick={(e) => {
					window.open(assetsReportingDashboardUrl);
				}}
			>
				<PieChartIcon />
			</IconButton>
		</Tooltip>
	);
}

export default AssetReportingBtn;
